import { useSnackbarStore } from '../store/useSnackbarStore';
import { SnackbarServiceImpl } from './SnackbarServiceImpl';
import { ISnackbarService } from './ISnackbarService';
import { SnackbarServiceLogDecorator } from './SnackbarServiceLogDecorator';
import { SnackbarServiceExceptionDecorator } from './SnackbarServiceExceptionDecorator';

export class SnackbarServiceFactory {
  private static instance: SnackbarServiceFactory | null = null;
  private snackbarStore: typeof useSnackbarStore;

  public static initialize(snackbarStore: typeof useSnackbarStore) {
    SnackbarServiceFactory.instance = new SnackbarServiceFactory(snackbarStore);
  }

  public static getInstance() {
    if (SnackbarServiceFactory.instance === null) {
      throw new Error(
        'SnackbarServiceFactory not yet initialized. Call SnackbarServiceFactory.initialize() first.',
      );
    }
    return SnackbarServiceFactory.instance;
  }

  private constructor(snackbarStore: typeof useSnackbarStore) {
    this.snackbarStore = snackbarStore;
  }

  public createSnackbarService(): ISnackbarService {
    let result: ISnackbarService = this.makeSnackbarService();

    result = new SnackbarServiceExceptionDecorator(result);
    result = new SnackbarServiceLogDecorator(result);

    return result;
  }

  private makeSnackbarService(): ISnackbarService {
    return new SnackbarServiceImpl(this.snackbarStore);
  }
}
